import { useEModeDialog } from './logic/useEModeDialog'
import { EModeView } from './views/EModeView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { EModeCategoryId } from '@/features/sparklend/common/data/market-info/emode'
import { withSuspense } from '@/ui/utils/withSuspense'

interface EModeDialogContentContainerProps {
  closeDialog: () => void
  userEModeCategoryId: EModeCategoryId
}

function EModeDialogContentContainer({ closeDialog, userEModeCategoryId }: EModeDialogContentContainerProps) {
  const {
    pageStatus,
    selectedEModeCategoryName,
    actionsViewState,
    currentPositionOverview,
    updatedPositionOverview,
    eModeCategories,
    validationIssue,
    riskAcknowledgement,
    showActions,
  } = useEModeDialog({ userEModeCategoryId })

  if (pageStatus.state === 'success') {
    return <SuccessView eModeCategoryName={selectedEModeCategoryName} onProceed={closeDialog} />
  }

  return (
    <EModeView
      selectedEModeCategoryName={selectedEModeCategoryName}
      actionsViewState={actionsViewState}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
      eModeCategories={eModeCategories}
      validationIssue={validationIssue}
      riskAcknowledgement={riskAcknowledgement}
      showActions={showActions}
    />
  )
}

const EModeDialogContentContainerWithSuspense = withSuspense(EModeDialogContentContainer, DialogContentSkeleton)
export { EModeDialogContentContainerWithSuspense as EModeDialogContentContainer }
